var _circle, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestManagerUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#DA3B11"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#DA3B11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8169 5H8.28171V5.69928H5.5V15H8.44014V13.8811H6.62676V6.81816H8.28171V7.51748H10.8169V6.81816H12.4718V7.67481H13.5986V5.69928H10.8169V5ZM9.30282 8.21676H15.5V15H9.30282V8.21676ZM10.4296 9.33564V13.8811H14.3732V9.33564H10.4296ZM11.1338 10.035H13.669V11.2937H11.1338V10.035ZM12.4014 11.9231H11.1338V13.1819H12.4014V11.9231Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestManagerUserIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxMC41IiBjeT0iMTAiIHI9IjEwIiBmaWxsPSIjREEzQjExIi8+CiAgPHJlY3QgeD0iMC41IiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIzIiBmaWxsPSIjREEzQjExIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC44MTY5IDVIOC4yODE3MVY1LjY5OTI4SDUuNVYxNUg4LjQ0MDE0VjEzLjg4MTFINi42MjY3NlY2LjgxODE2SDguMjgxNzFWNy41MTc0OEgxMC44MTY5VjYuODE4MTZIMTIuNDcxOFY3LjY3NDgxSDEzLjU5ODZWNS42OTkyOEgxMC44MTY5VjVaTTkuMzAyODIgOC4yMTY3NkgxNS41VjE1SDkuMzAyODJWOC4yMTY3NlpNMTAuNDI5NiA5LjMzNTY0VjEzLjg4MTFIMTQuMzczMlY5LjMzNTY0SDEwLjQyOTZaTTExLjEzMzggMTAuMDM1SDEzLjY2OVYxMS4yOTM3SDExLjEzMzhWMTAuMDM1Wk0xMi40MDE0IDExLjkyMzFIMTEuMTMzOFYxMy4xODE5SDEyLjQwMTRWMTEuOTIzMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };